/**
 * Settings page with profile and API key management sections.
 *
 * Two vertically stacked sections:
 * 1. Profile -- user name editing, read-only email
 * 2. API Keys -- create, list, revoke API keys
 */

import { useApiQuery } from "@frontend/hooks/use-api"
import { ApiKeyListContainer } from "@frontend/pages/settings/components/api-key-list"
import { AppInfo } from "@frontend/pages/settings/components/app-info"
import { UserProfileContainer } from "@frontend/pages/settings/components/user-profile"
import { Settings } from "lucide-react"

export function SettingsPage() {
  const { data: currentUser } = useApiQuery<{
    can_create_api_keys: boolean
  }>(["auth", "me"], "/auth/me")

  return (
    <div className="space-y-6 max-w-4xl mx-auto">
      <div className="flex items-center gap-3">
        <Settings className="h-6 w-6" />
        <div>
          <h1>Settings</h1>
          <p className="text-muted-foreground text-[12px]">
            {currentUser?.can_create_api_keys ? "Manage your profile and API keys." : "Manage your profile."}
          </p>
        </div>
      </div>
      <UserProfileContainer />
      {currentUser?.can_create_api_keys && <ApiKeyListContainer />}
      <AppInfo />
    </div>
  )
}
